import { Modal } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";

export default function ProductionArticlesFinalizedModal({ showFinalizedModal, setShowFinalizedModal }) {
	const { t } = useTranslation();

	return (
		<Modal open size="tiny">
			<Modal.Content>
				<i>{`${t(
					"productionWasFinalized",
					"Production was finanlized and delivered.",
				)} Delivery duration: ${showFinalizedModal}`}</i>
			</Modal.Content>

			<Modal.Actions>
				<PrimaryButton onClick={() => setShowFinalizedModal(false)}>{t("ok", "OK")}</PrimaryButton>
			</Modal.Actions>
		</Modal>
	);
}
